export default __webpack_public_path__ + "static/BioRhymeExpanded-Regular-hint-all-6a77499d0e2287cc1fa2a2173a3933e4.woff2";